(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[873],{

/***/ 48381:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/conference",
      function () {
        return __webpack_require__(65794);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 65794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_pagelay__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28082);
/* harmony import */ var _utils_useHead__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25838);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(73424);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81627);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_useRequest__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54013);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2261);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25194);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_7__);












var __N_SSP = true;
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(param) {
    var navDetail = param.navDetail;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), data = ref[0], setData = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), select_cate = ref1[0], setSelectCate = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}), details = ref2[0], setDetails = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(5), perView = ref3[0], setPerView = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), imageList = ref4[0], setImageList = ref4[1];
    var t = (0,next_intl__WEBPACK_IMPORTED_MODULE_8__/* .useTranslations */ .T_)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var request = (0,_utils_useRequest__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    var swiperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var $swiper = (0,swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .useSwiper */ .oc)();
    console.log("router");
    console.log("13123123123123");
    // t('common.title') 是多语言的方法，在locales下有对应的cn和en文件
    var getData = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
        var ref, _data, list, id;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        request.get("/getEventList", {
                            params: {
                                category_name: navDetail.name
                            }
                        })
                    ];
                case 1:
                    ref = _state.sent(), _data = ref.data, list = _data.data.list;
                    if (list.length) {
                        id = list[0].id;
                        setData(list);
                        setSelectCate(id);
                        getDetails(id);
                    }
                    return [
                        2
                    ];
            }
        });
    }), []);
    var getDetails = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(event_id) {
            var ref, data, content_cn, content_en, img_start, img_end, img_code, style_code, editor_code, view_code, urlRegex, imgSrcs, img_start1, img_end1, img_code1, style_code1, editor_code1, view_code1, urlRegex1, imgSrcs1;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            request.get("/getEvent", {
                                params: {
                                    id: event_id
                                }
                            })
                        ];
                    case 1:
                        ref = _state.sent(), data = ref.data.data;
                        content_cn = data.content_cn, content_en = data.content_en;
                        if (content_cn.indexOf('<div class="meetTitle') !== -1) {
                            img_start = content_cn.indexOf("<p>");
                            img_end = content_cn.indexOf('<div class="meetTitle"');
                            img_code = content_cn.slice(img_start, img_end);
                            style_code = content_cn.slice(0, img_start);
                            editor_code = content_cn.slice(img_end);
                            view_code = style_code + editor_code;
                            data.content_cn = view_code;
                            urlRegex = /https?:\/\/[^\s"'<>]+/g;
                            imgSrcs = img_code.match(urlRegex);
                            setImageList(imgSrcs);
                        }
                        if (content_en.indexOf('<div class="meetTitle') !== -1) {
                            img_start1 = content_en.indexOf("<p>");
                            img_end1 = content_en.indexOf('<div class="meetTitle"');
                            img_code1 = content_en.slice(img_start1, img_end1);
                            style_code1 = content_en.slice(0, img_start1);
                            editor_code1 = content_en.slice(img_end1);
                            view_code1 = style_code1 + editor_code1;
                            data.content_en = view_code1;
                            urlRegex1 = /https?:\/\/[^\s"'<>]+/g;
                            imgSrcs1 = img_code1.match(urlRegex1);
                            setImageList(imgSrcs1);
                        }
                        swiperRef.current.swiper.slideTo(0);
                        setDetails(data);
                        return [
                            2
                        ];
                }
            });
        });
        return function(event_id) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var selectCateItem = function(cate_id) {
        setSelectCate(cate_id);
        getDetails(cate_id);
    };
    var prev = function() {
        swiperRef.current.swiper.slidePrev();
    };
    var next = function() {
        swiperRef.current.swiper.slideNext();
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        getData();
        if (document.documentElement.clientWidth < 888) {
            setPerView(3);
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pagelay__WEBPACK_IMPORTED_MODULE_2__/* .PageLayout */ .X, {
        temp: "page_crumb",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().container),
            children: [
                (0,_utils_useHead__WEBPACK_IMPORTED_MODULE_3__/* .getHead */ .c)(navDetail),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().tabs),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().cateBox),
                        children: data.map(function(item) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().cateItem), " ").concat(item.id == select_cate ? (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().cateActive) : ""),
                                onClick: function(e) {
                                    return selectCateItem(item.id);
                                },
                                style: {
                                    width: router.locale === "cn" ? "auto" : "calc((100% - 96px)/5)"
                                },
                                children: item["name_".concat(router.locale)]
                            }, item.id);
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().body),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().bodyBox),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().title),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().titleBox),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "/image/symbol-left-dot.png"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().titleText),
                                                children: details["name_".concat(router.locale)]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "/image/symbol-right-dot.png"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: "/image/symbol.png"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().description),
                                children: details["brief_".concat(router.locale)]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().swiper),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .Swiper */ .tq, {
                                        spaceBetween: 14,
                                        slidesPerView: perView,
                                        ref: swiperRef,
                                        children: imageList.map(function(item) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .SwiperSlide */ .o5, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().imageItem),
                                                    src: item
                                                })
                                            }, item);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        onClick: function() {
                                            return prev();
                                        },
                                        className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().btn), " ").concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().left)),
                                        src: "/image/left-arrow.png"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        onClick: function() {
                                            return next();
                                        },
                                        className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().btn), " ").concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().right)),
                                        src: "/image/right-arrow.png"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().editor),
                                dangerouslySetInnerHTML: {
                                    __html: details["content_".concat(router.locale)]
                                }
                            })
                        ]
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 25838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ getHead; }
/* harmony export */ });
/* unused harmony export getServerSideProps */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_request__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45844);





var getServerSideProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(context) {
        var ref, data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("/getHomeMenuDetail", {
                            params: {
                                path: context === null || context === void 0 ? void 0 : (ref = context.resolvedUrl) === null || ref === void 0 ? void 0 : ref.split("?")[0]
                            },
                            headers: {
                                lang: (context === null || context === void 0 ? void 0 : context.locale) || "cn"
                            }
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        {
                            props: {
                                navDetail: data.data || null,
                                menuDetail: data.data || null
                            }
                        }
                    ];
            }
        });
    });
    return function getServerSideProps(context) {
        return _ref.apply(this, arguments);
    };
}();
var getHead = function(menuDetail) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            (menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_title) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                children: [
                    menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_title,
                    " "
                ]
            }),
            (menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_kws) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_kws
            }),
            (menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_desc) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_desc
            })
        ]
    });
};



/***/ }),

/***/ 73424:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"m-1480":"conference_m-1480__qt2T2","container":"conference_container__C5K30","tabs":"conference_tabs__pDQ0D","cateBox":"conference_cateBox__A6hkB","cateItem":"conference_cateItem___5_dL","cateActive":"conference_cateActive__b5n_U","body":"conference_body__mVMu6","bodyBox":"conference_bodyBox__sHXGv","title":"conference_title__lrxBe","titleBox":"conference_titleBox__FT0PN","titleText":"conference_titleText__jqbOO","description":"conference_description__DEju6","swiper":"conference_swiper__nRVx8","imageItem":"conference_imageItem__Ze328","btn":"conference_btn__oLVZN","left":"conference_left__9w5rz","right":"conference_right__u9zvo","devide":"conference_devide__WTx_a","editor":"conference_editor__dZmhJ","imageBox":"conference_imageBox__EE2P5","rowItem":"conference_rowItem__C9Di8","groupImage":"conference_groupImage__VBFU_","topImage":"conference_topImage__LV3WL","bottomImage":"conference_bottomImage___hyJ6","space":"conference_space__8dAkS","meetTitle":"conference_meetTitle__yakPs","infoItem":"conference_infoItem__Auz0L","label":"conference_label__bpw43","tag":"conference_tag__jqQ6w","other":"conference_other__PCppE","value":"conference_value__yzw1R","otherValue":"conference_otherValue__M7G15","schedule":"conference_schedule__tza69","scheduleContent":"conference_scheduleContent__ZJxjv","scheduleItem":"conference_scheduleItem__bgdnH","scheduleTitle":"conference_scheduleTitle__XHz4y","scroll":"conference_scroll___iGQc","contentHeader":"conference_contentHeader__DFLjQ","middleDivide":"conference_middleDivide__Pki_P","contentBody":"conference_contentBody__DsxF9","divide":"conference_divide__dre_1","itemBackground":"conference_itemBackground__nbKJS","time":"conference_time__QcJjE","spots":"conference_spots__rojBh","item":"conference_item__Zk9HD","scrollBody":"conference_scrollBody__egKFb"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [222,912,774,888,179], function() { return __webpack_exec__(48381); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);